import React, { useEffect, useState } from "react";
import axios from "axios";
import useSEO from "../../hooks/useSEO";
import { MyApi } from "../../MyApi";  
import HomeBlog from "./HomeBlog";

export default function Home() {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + "site-setting", {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status && res.data.data) {
          setSeoData(res.data.data);
        }
      } catch (err) {
        console.error("SEO API error", err);
      }
    };

    fetchSEO();
  }, []);

  // 🔹 Apply SEO only when API data is ready
  useSEO(
    seoData
      ? {
          title: seoData.metatitle,
          description: seoData.description,
          keywords: seoData.keywords,
          canonical: seoData.canonical || "",
          ogImage: seoData.ogImage || "",
        }
      : {}
  );

  return (
    <div> 
     <HomeBlog limit={6} />
    </div>
  );
}
